import { RootState } from '@/store';
import { Form, InputNumber } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateLaborTab } from '../../../../../contextRedux/Offer/OfferModel';
import DevicesTable from './DevicesTable/DevicesTable';
import './LaborTab.css';
import LaborTable from './LaborTable/LaborTable';

interface LaborTabProps {}

const LaborTab: React.FC<LaborTabProps> = ({}) => {
  const dispatch = useDispatch();
  const offer = useSelector((state: RootState) => state?.models?.offer);

  const handleLaborPriceChange = (value: number | null) => {
    if (value !== null) {
      dispatch(updateLaborTab({ field: 'laborPriceOnHour', value: value ?? 300 }));
    }
  };

  return (
    <div>
      <div className='estimate-container'>
        <h1>Costuri estimate</h1>
        <Form.Item label='Pret manopera per ora' className='formItem'>
          <InputNumber
            placeholder='Ex: 300'
            value={offer.laborTab.laborPriceOnHour ?? 300}
            onChange={handleLaborPriceChange}
          />
        </Form.Item>
      </div>
      <DevicesTable />
      <div style={{ height: 25 }}></div>
      {<LaborTable key={'id'} />}
      <div style={{ height: 25 }}></div>
    </div>
  );
};

export default LaborTab;
